import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Trophy } from 'lucide-react';
import axios, { API_URL } from '../../utils/axiosConfig';
import { useAuth } from '../../contexts/AuthContext';

function HomePage() {
  const navigate = useNavigate();
  const { currentUser } = useAuth();
  const [rankings, setRankings] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadRankings();
  }, []);

  const loadRankings = async () => {
    try {
      const response = await axios.get(`${API_URL}/rankings`);
      setRankings(response.data);
    } catch (error) {
      console.error('Erreur chargement classement:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-5xl mx-auto space-y-6 md:space-y-8 px-4 sm:px-6 lg:px-8 animate-fadeIn">
      <div className="bg-white rounded-xl shadow-lg p-6 sm:p-8 border border-gray-200">
        <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-3 text-center">
          🏈 Bienvenue à Touchdown League !
        </h2>
        <p className="text-sm sm:text-base text-gray-700 text-center mb-4">
          Pronostique les marqueurs de touchdowns et accumule des points !
        </p>

        {!currentUser && (
          <div className="flex flex-col sm:flex-row justify-center gap-3 sm:space-x-3">
            <button
              onClick={() => navigate('/login')}
              className="w-full sm:w-auto px-6 py-3 sm:py-2 bg-blue-900 text-white rounded-lg hover:bg-blue-950 transition text-sm font-semibold"
            >
              Se connecter
            </button>
            <button
              onClick={() => navigate('/register')}
              className="w-full sm:w-auto px-6 py-3 sm:py-2 bg-green-700 text-white rounded-lg hover:bg-green-800 transition text-sm font-semibold"
            >
              S'inscrire
            </button>
          </div>
        )}
      </div>

      <div className="bg-white rounded-lg shadow-md p-4 sm:p-6">
        <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-4 flex items-center">
          <Trophy className="w-5 h-5 sm:w-6 sm:h-6 mr-2 text-yellow-500" />
          Classement Général
        </h3>

        {loading ? (
          <div className="text-center py-6">
            <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-blue-600 mx-auto"></div>
            <p className="text-gray-700 mt-3 text-sm">Chargement...</p>
          </div>
        ) : rankings.length === 0 ? (
          <div className="text-center py-6">
            <p className="text-gray-700">Aucun joueur inscrit.</p>
          </div>
        ) : (
          <div className="space-y-2">
            {rankings.map((player, index) => (
              <div
                key={player.id}
                className={`flex items-center justify-between p-3 sm:p-4 rounded-lg ${
                  index === 0 ? 'bg-yellow-50 border border-yellow-200' :
                  index === 1 ? 'bg-gray-100 border border-gray-300' :
                  index === 2 ? 'bg-orange-50 border border-orange-200' :
                  'bg-gray-50'
                }`}
              >
                <div className="flex items-center space-x-2 sm:space-x-3 flex-1 min-w-0">
                  <span className={`text-base sm:text-lg font-bold w-7 sm:w-8 flex-shrink-0 ${
                    index === 0 ? 'text-yellow-600' :
                    index === 1 ? 'text-gray-700' :
                    index === 2 ? 'text-orange-600' :
                    'text-gray-600'
                  }`}>
                    #{index + 1}
                  </span>
                  <div className="min-w-0 flex-1">
                    <p className="font-semibold text-gray-900 text-sm sm:text-base truncate">
                      {player.username}
                    </p>
                    <p className="text-xs text-gray-600 sm:hidden">{player.totalPoints || player.points || 0} pts</p>
                  </div>
                </div>
                <div className="text-right flex-shrink-0 ml-2">
                  <p className="text-lg sm:text-xl font-bold text-blue-900">{player.totalPoints || player.points || 0}</p>
                  <p className="text-xs text-gray-600 hidden sm:block">points</p>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default HomePage;
